import camelCase from 'lodash/camelCase'
import isPlainObject from 'lodash/isPlainObject'

const objectKeysToCamelCase = (object) => {
  if (Array.isArray(object)) {
    return object.map((item) => objectKeysToCamelCase(item))
  } else if (isPlainObject(object)) {
    return Object.keys(object).reduce((acc, key) => {
      const camelKey = camelCase(key)
      acc[camelKey] = objectKeysToCamelCase(object[key])
      return acc
    }, {})
  }
  return object
}

export default class ApiResponse {
  constructor(response) {
    this.handleHttpError(response)
    this.handleHttpResponseData(response.data)
  }

  handleHttpError(response) {
    if (response.status !== 200) {
      if (response.message) {
        throw new Error(response.message)
      }
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  }

  handleHttpResponseData(responseData) {
    const data = responseData.data
    if (responseData.status === 'fail') {
      throw new Error(data.message, {
        cause: data.code,
      })
    } else {
      this.data = objectKeysToCamelCase(data)
    }
  }

  toModel(model) {
    if (model) {
      return new model(this.data)
    }

    return this.data
  }
}
